import { SVGProps } from 'react';

export const Arrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      stroke="#282828"
      strokeWidth={1.5}
      d="M3.776 6.356 9 11.58l5.225-5.224"
    />
  </svg>
);

export const SliderArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={18}
    fill="none"
    {...props}
  >
    <path
      d="M0.842946 14.7891L0.842923 14.7891C0.61941 15.0637 0.5 15.4269 0.5 15.7974C0.5 16.1679 0.61941 16.5311 0.842923 16.8057L0.842969 16.8057C1.06771 17.0816 1.3848 17.25 1.72934 17.25C2.07388 17.25 2.39098 17.0816 2.61571 16.8057L2.61574 16.8057L8.15705 10.001L8.15708 10.001C8.38059 9.72645 8.5 9.36327 8.5 8.99274C8.5 8.62221 8.38059 8.25903 8.15708 7.98447L8.15705 7.98444L2.61574 1.1798L2.61577 1.17977L2.61301 1.17651C2.38646 0.907814 2.0709 0.746424 1.7302 0.750059C1.38965 0.753695 1.07705 0.921623 0.854878 1.19445C0.633797 1.46593 0.514464 1.82421 0.511871 2.19065C0.509278 2.5571 0.62352 2.91746 0.840297 3.19307L0.840269 3.1931L0.842946 3.19638L5.56317 8.99274L0.842946 14.7891Z"
      fill="#4C4C4C"
      stroke="#4C4C4C"
      strokeWidth="0.5"
    />
  </svg>
);

export const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox={'0 0 165 27'}
    {...props}
  >
    <path
      fill="#282828"
      d="M12.688 13.745H9.101v5.25c0 1.623.415 2.152 1.888 2.152h.642v5.286H9.25c-3.549 0-5.852-1.699-5.852-5.89v-6.798H0V8.987h3.399V2.001H9.1v6.986h3.587v4.758ZM26.974 8.459v5.702h-.491c-3.814 0-5.363 1.397-5.363 5.853v6.42h-5.702V8.986h5.59v3.55h.075c1.02-2.87 3.02-4.078 5.777-4.078h.114ZM52.437 8.987h5.626L51.72 26.433h-4.871l-3.852-10.195-3.814 10.195h-4.871L27.929 8.987h5.665l3.247 10.234 3.55-10.234h5.248l3.55 10.234 3.248-10.234ZM65.723 0v26.433h-5.702V0h5.702Z"
    />
    <path
      fill="#A9D0CD"
      d="M74.413 21.94v4.494h-4.494V21.94h4.494ZM84.515 27c-2.492 0-5.098-.68-7.1-1.85l1.662-3.286c1.624.944 3.474 1.662 5.551 1.662 1.775 0 2.72-.529 2.72-1.624 0-.717-.379-1.246-1.851-1.963l-3.172-1.549c-2.644-1.246-3.663-3.02-3.663-5.022 0-3.21 2.379-4.947 6.193-4.947 2.001 0 4.191.529 6.042 1.36l-1.51 3.21c-1.322-.567-2.946-1.133-4.645-1.133-1.624 0-2.153.528-2.153 1.321 0 .83.491 1.36 2.001 2.077l3.248 1.548c2.266 1.058 3.474 2.568 3.474 4.91 0 3.549-2.719 5.286-6.797 5.286ZM103.37 12.122h-3.55v9.138c0 1.246.529 1.813 1.813 1.813h.906v3.398h-1.699c-3.059 0-4.72-1.623-4.72-4.493v-9.856h-3.097V8.988h3.097V2.002h3.7v6.986h3.55v3.134ZM114.437 8.421c5.475 0 9.554 3.927 9.554 9.29 0 5.362-4.079 9.29-9.554 9.29-5.476 0-9.554-3.928-9.554-9.29 0-5.363 4.078-9.29 9.554-9.29Zm0 3.625c-3.323 0-5.627 2.228-5.627 5.665 0 3.436 2.304 5.664 5.627 5.664s5.626-2.228 5.626-5.664c0-3.437-2.303-5.665-5.626-5.665ZM137.6 8.459v4.343h-.566c-3.625 0-5.551 1.737-5.551 5.89v7.742h-3.701V8.988h3.701v3.814h.075c.831-2.606 2.833-4.343 5.778-4.343h.264ZM147.444 8.421c5.325 0 8.346 3.663 8.346 9.29v.604h-13.519c.151 3.096 2.304 5.135 5.287 5.135 2.87 0 4.493-1.888 5.362-3.058l2.606 2.454c-1.284 1.775-3.588 4.154-7.893 4.154-5.551 0-9.1-3.738-9.1-9.252 0-5.286 3.323-9.327 8.911-9.327Zm-.226 3.399c-2.492 0-4.305 1.284-4.758 3.814h9.327c-.151-2.417-1.926-3.814-4.569-3.814Z"
    />
  </svg>
);

export const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#282828"
      d="M9.167 16.5a7.29 7.29 0 0 0 4.489-1.547l4.03 4.03 1.295-1.297-4.03-4.03a7.29 7.29 0 0 0 1.549-4.49c0-4.043-3.29-7.333-7.333-7.333-4.044 0-7.334 3.29-7.334 7.334 0 4.043 3.29 7.333 7.334 7.333Zm0-12.833c3.033 0 5.5 2.466 5.5 5.5 0 3.033-2.467 5.5-5.5 5.5a5.506 5.506 0 0 1-5.5-5.5c0-3.034 2.466-5.5 5.5-5.5Z"
    />
  </svg>
);

export const Cart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#282828"
      d="M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a.999.999 0 0 0-.115-.921ZM17.307 15h-6.64l-2.5-6h11.39l-2.25 6ZM10.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);

export const Vk = ({ width, height, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 18}
    height={height || 10}
    fill="none"
    {...props}
  >
    <path
      fill="#6C6C6C"
      d="M16.983.713c.116-.388 0-.672-.552-.672h-1.828c-.465 0-.677.246-.794.516 0 0-.929 2.266-2.246 3.735-.425.427-.619.562-.85.562-.116 0-.285-.135-.285-.522V.712c0-.464-.134-.671-.521-.671H7.035c-.29 0-.465.215-.465.42 0 .44.658.542.726 1.782v2.69c0 .589-.106.696-.34.696-.618 0-2.125-2.274-3.02-4.877-.173-.506-.35-.71-.816-.71H1.293C.771.042.667.288.667.558c0 .485.619 2.885 2.884 6.059 1.51 2.167 3.636 3.342 5.572 3.342 1.161 0 1.305-.26 1.305-.71V7.61c0-.522.11-.627.478-.627.27 0 .735.137 1.819 1.181 1.238 1.239 1.443 1.794 2.14 1.794h1.826c.521 0 .782-.26.632-.775-.164-.513-.756-1.259-1.54-2.141-.427-.504-1.065-1.045-1.259-1.316-.27-.35-.192-.503 0-.813.001 0 2.227-3.135 2.459-4.2Z"
    />
  </svg>
);

export const Instagram = ({
  width,
  height,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 20}
    height={height || 20}
    fill="none"
    {...props}
  >
    <path
      fill="#6C6C6C"
      d="M17.456 6.92a5.442 5.442 0 0 0-.35-1.846 3.842 3.842 0 0 0-2.194-2.194 5.506 5.506 0 0 0-1.821-.35c-.802-.036-1.056-.046-3.091-.046s-2.296 0-3.092.046a5.505 5.505 0 0 0-1.82.35 3.84 3.84 0 0 0-2.195 2.194 5.462 5.462 0 0 0-.349 1.821c-.036.802-.046 1.057-.046 3.092s0 2.295.046 3.091c.013.624.13 1.239.35 1.823a3.841 3.841 0 0 0 2.194 2.193 5.485 5.485 0 0 0 1.821.375c.803.036 1.057.047 3.092.047s2.296 0 3.091-.047a5.492 5.492 0 0 0 1.822-.349 3.847 3.847 0 0 0 2.194-2.194c.22-.584.337-1.199.35-1.823.035-.801.046-1.056.046-3.091-.002-2.035-.002-2.294-.048-3.091Zm-7.461 6.915a3.852 3.852 0 1 1-.002-7.703 3.852 3.852 0 0 1 .002 7.703Zm4.006-6.95a.898.898 0 1 1-.002-1.794.898.898 0 0 1 .002 1.795Z"
    />
    <path
      fill="#6C6C6C"
      d="M9.995 12.485a2.502 2.502 0 1 0 0-5.005 2.502 2.502 0 0 0 0 5.005Z"
    />
  </svg>
);

export const Telegram = ({
  width,
  height,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 20}
    height={height || 20}
    fill="none"
    {...props}
  >
    <path
      fill="#6C6C6C"
      d="M17.22 3.097 2.447 8.795c-1.009.405-1.003.967-.185 1.218l3.793 1.184 8.777-5.538c.415-.252.794-.117.482.16l-7.11 6.418H8.2h.002l-.262 3.91c.383 0 .552-.175.767-.383l1.843-1.791 3.832 2.83c.707.39 1.215.19 1.39-.654L18.29 4.292c.258-1.032-.394-1.5-1.068-1.195Z"
    />
  </svg>
);

export const Phone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#6C6C6C"
      d="M16.667 9.166h1.666c0-4.275-3.227-7.5-7.508-7.5v1.667c3.385 0 5.842 2.453 5.842 5.833Z"
    />
    <path
      fill="#6C6C6C"
      d="M10.833 6.667c1.753 0 2.5.747 2.5 2.5H15C15 6.479 13.52 5 10.833 5v1.667Zm2.852 4.536a.834.834 0 0 0-1.16.035l-1.993 2.051c-.48-.091-1.445-.392-2.439-1.383C7.1 10.912 6.8 9.944 6.71 9.467l2.05-1.995a.833.833 0 0 0 .035-1.159l-3.08-3.385a.833.833 0 0 0-1.158-.073l-1.809 1.55a.833.833 0 0 0-.241.542c-.013.208-.251 5.143 3.575 8.971 3.339 3.338 7.52 3.582 8.672 3.582.168 0 .272-.005.3-.007a.827.827 0 0 0 .54-.242l1.55-1.81a.834.834 0 0 0-.072-1.159l-3.387-3.08Z"
    />
  </svg>
);

export const LocationPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#6C6C6C"
      d="M10 1.667c-3.676 0-6.667 2.99-6.667 6.662C3.31 13.7 9.747 18.153 10 18.333c0 0 6.69-4.633 6.667-10A6.674 6.674 0 0 0 10 1.667Zm0 10a3.332 3.332 0 1 1 3.333-3.333A3.332 3.332 0 0 1 10 11.666Z"
    />
  </svg>
);

export const Plus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={6}
    fill="none"
    {...props}
  >
    <path
      fill="#282828"
      d="M2.59 6V3.414H0v-.828h2.59V0h.827v2.586H6v.828H3.417V6H2.59Z"
    />
  </svg>
);

export const Minus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={2}
    fill="none"
    {...props}
  >
    <path fill="#282828" d="M0 1.323V0h6.3v1.323H0Z" />
  </svg>
);

export const Ok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill={props.color || 'none'}
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill={props.color || 'none'}
      d="m12.5 19.483-4.116-4.117-1.768 1.768 5.884 5.883 12.134-12.133-1.768-1.768L12.5 19.483Z"
    />
  </svg>
);

export const XMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={30}
    height={30}
    xmlns="http://www.w3.org/2000/svg"
    fill={props.color || 'none'}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color || 'none'}
      fillRule="evenodd"
      d="M3.47 3.47a.75.75 0 0 1 1.06 0L8 6.94l3.47-3.47a.75.75 0 1 1 1.06 1.06L9.06 8l3.47 3.47a.75.75 0 1 1-1.06 1.06L8 9.06l-3.47 3.47a.75.75 0 0 1-1.06-1.06L6.94 8 3.47 4.53a.75.75 0 0 1 0-1.06"
      clipRule="evenodd"
    />
  </svg>
);

export const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#DE392E"
      d="M9.917 1.167c-1.143 0-2.176.469-2.917 1.225A4.083 4.083 0 0 0 0 5.25c0 2.255 2.333 4.083 7 7.583 4.667-3.5 7-5.328 7-7.583a4.083 4.083 0 0 0-4.083-4.083Z"
    />
  </svg>
);

export const Payment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="29"
    viewBox="0 0 24 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1163_1972)">
      <path
        d="M0 6.3125L3.55886 12.5898V16.4188L0.00416327 22.6837L0 6.3125Z"
        fill="#5B57A2"
      />
      <path
        d="M13.665 10.3055L16.9998 8.28851L23.8246 8.28223L13.665 14.4239V10.3055Z"
        fill="#D90751"
      />
      <path
        d="M13.646 6.27536L13.6648 14.5863L10.0977 12.4234V0L13.646 6.27536Z"
        fill="#FAB718"
      />
      <path
        d="M23.8244 8.28216L16.9994 8.28844L13.646 6.27536L10.0977 0L23.8244 8.28216Z"
        fill="#ED6F26"
      />
      <path
        d="M13.6648 22.7185V18.6863L10.0977 16.5645L10.0996 29.0001L13.6648 22.7185Z"
        fill="#63B22F"
      />
      <path
        d="M16.991 20.7199L3.55861 12.5898L0 6.3125L23.8097 20.7117L16.991 20.7199Z"
        fill="#1487C9"
      />
      <path
        d="M10.0996 28.9999L13.6643 22.7182L16.9908 20.7196L23.8095 20.7114L10.0996 28.9999Z"
        fill="#017F36"
      />
      <path
        d="M0.00390625 22.6834L10.1263 16.5644L6.72317 14.5039L3.5586 16.4184L0.00390625 22.6834Z"
        fill="#984995"
      />
    </g>
    <defs>
      <clipPath id="clip0_1163_1972">
        <rect width="24" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Car = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#D90751"
      d="M22.285 12.203v-.012a.471.471 0 0 0-.473-.463h-.125l-1.92-3.713a.472.472 0 0 0-.421-.254l-3.279-.001.125-.992a1.361 1.361 0 0 0-.345-1.053 1.352 1.352 0 0 0-1.013-.438H4.658a.503.503 0 0 0-.497.453l-.102.817h5.798a.66.66 0 0 1 .663.681.704.704 0 0 1-.7.682H7.888l.001.003H2.209a.498.498 0 0 0-.494.482.467.467 0 0 0 .469.482h7.518c.35.054.61.356.6.721a.754.754 0 0 1-.743.73H4.376a.503.503 0 0 0-.5.487.472.472 0 0 0 .474.487h5.122c.354.05.62.354.61.723a.754.754 0 0 1-.749.73h-6.37a.503.503 0 0 0-.5.487.472.472 0 0 0 .475.487h.426l-.167 1.744c-.036.396.087.77.345 1.054.258.282.618.438 1.013.438h.368a2.124 2.124 0 0 0 2.102 1.758c1.06 0 1.966-.756 2.194-1.758h4.587c.37 0 .722-.142.998-.374.251.241.585.374.95.374h.075a2.124 2.124 0 0 0 2.102 1.758c1.06 0 1.966-.756 2.194-1.758h.303c.788 0 1.488-.641 1.559-1.43l.297-3.286v-.014l.002-.02v-.012ZM7.05 17.75a1.18 1.18 0 0 1-1.185-1.218 1.258 1.258 0 0 1 1.25-1.217 1.18 1.18 0 0 1 1.184 1.217A1.258 1.258 0 0 1 7.05 17.75Zm10.906 0a1.18 1.18 0 0 1-1.185-1.218 1.258 1.258 0 0 1 1.25-1.217 1.18 1.18 0 0 1 1.184 1.217 1.258 1.258 0 0 1-1.249 1.218Zm3.06-2.277a.586.586 0 0 1-.563.518h-.327a2.124 2.124 0 0 0-2.08-1.65c-1.022 0-1.9.703-2.167 1.65h-.1a.413.413 0 0 1-.311-.13.419.419 0 0 1-.102-.326l.613-6.801h1.41l-.223 2.476c-.036.396.087.77.345 1.054.257.282.617.438 1.013.438h2.743l-.25 2.771Z"
    />
  </svg>
);

export const Certificate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#D90751"
        d="M11.779 3a.669.669 0 0 0-.442.18l-1.238 1.17-1.414-.27c-.442-.09-.707.18-.796.54l-.265 1.62-1.502.72c-.354.18-.442.54-.266.9l.708 1.44-.708 1.44c-.176.36 0 .72.266.9l1.502.72.266 1.62c.088.36.441.63.795.54l1.68-.27 1.237 1.17c.265.27.707.27.973 0l1.237-1.17 1.68.27c.353.09.707-.18.795-.54l.265-1.62 1.503-.72c.354-.18.442-.54.265-.9l-.972-1.44.707-1.44c.177-.36.089-.72-.265-.9l-1.503-.72-.265-1.62c-.088-.36-.442-.63-.795-.54l-1.68.27-1.238-1.17C12.221 3 11.956 3 11.78 3ZM6.74 12.99 4 18.57l3.182-.45L8.773 21l2.299-4.77-.177-.18-.884-.81-1.238.18c-.795.09-1.59-.45-1.767-1.26l-.266-1.17Zm10.431 0-.265 1.17c-.177.72-.796 1.26-1.503 1.26h-.177l-1.237-.18-.884.81-.177.18L15.226 21l1.592-2.79 3.182.45-2.829-5.67Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MoneyFlow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#282828"
      d="M10.905 14.508c.093-.1.191-.195.275-.302.316-.406.627-.818.94-1.226.314-.41.632-.821.948-1.231l1.52-1.978c.031-.038.06-.077.085-.118.045-.073.038-.147-.01-.215a.175.175 0 0 0-.211-.063c-.283.107-.563.219-.844.33l-1.56.614c-.008.004-.018.005-.036.01V.232c0-.165-.066-.232-.232-.232H9.913c-.159 0-.224.064-.225.222-.002.2 0 .4 0 .599v9.511l-.538-.21-1.858-.734c-.112-.045-.199-.025-.258.056-.053.072-.043.17.022.254a422.45 422.45 0 0 1 1.798 2.336l1.156 1.506c.222.289.443.58.667.867.03.04.08.067.12.1h.108ZM3.905 0c.093.1.191.195.275.301.316.407.627.818.94 1.227l.947 1.231L7.59 4.737c.03.037.058.077.084.118.045.073.038.147-.01.215a.175.175 0 0 1-.211.063c-.282-.108-.563-.219-.844-.33l-1.56-.614c-.008-.004-.018-.005-.036-.01v10.097c0 .165-.066.232-.232.232H2.913c-.159 0-.224-.064-.225-.222-.002-.2 0-.4 0-.6v-9.51l-.538.21-1.858.734c-.112.044-.199.025-.258-.057-.053-.072-.043-.17.022-.254a434.921 434.921 0 0 0 1.798-2.335L3.01.968c.222-.29.443-.58.667-.867.03-.04.08-.067.12-.1L3.906 0ZM19.973 11.93v1.48c0 .294.004.589-.002.883-.01.405-.262.71-.642.79a.778.778 0 0 1-.87-.45 1.065 1.065 0 0 1-.075-.395c-.007-.72-.003-1.442-.003-2.163v-.151h-.135c-.473 0-.946.003-1.42 0-.492-.006-.842-.366-.823-.843.015-.366.308-.699.674-.733.25-.023.503-.014.755-.015.31-.002.62 0 .94 0V8.744h-.12c-.492 0-.985.004-1.477-.001a.786.786 0 0 1-.763-.658.78.78 0 0 1 .47-.858.953.953 0 0 1 .338-.065c.473-.007.946-.003 1.42-.003h.141V2.443c0-.56.155-1.071.507-1.511.463-.582 1.07-.906 1.814-.913 1.236-.013 2.474-.038 3.71.005 1.632.058 2.888.823 3.716 2.227 1.396 2.365.222 5.28-2.213 6.21-.467.178-.952.279-1.453.28-1.427.004-2.853.005-4.28.003h-.202v1.588h6.27c.403 0 .7.192.82.527.188.526-.194 1.058-.772 1.063-.679.006-1.357.002-2.036.002H20.1c-.037 0-.075.003-.127.006Zm0-4.771h.345c1.33 0 2.659.003 3.989 0 1.524-.004 2.749-1.172 2.809-2.673.06-1.523-1.261-2.876-2.827-2.884-1.166-.006-2.333-.002-3.5 0a.924.924 0 0 0-.274.041c-.349.11-.542.406-.543.816V7.16Z"
    />
  </svg>
);

export const MoneyFlowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#282828"
      d="M3.905 14.508c.093-.1.191-.195.275-.302.316-.406.627-.818.94-1.226.314-.41.632-.821.947-1.231L7.59 9.77c.03-.038.058-.077.084-.118.045-.073.038-.147-.01-.215a.175.175 0 0 0-.211-.063c-.282.107-.563.219-.844.33l-1.56.614c-.008.004-.018.005-.036.01V.232C5.012.067 4.946 0 4.78 0H2.913c-.159 0-.224.064-.225.222-.002.2 0 .4 0 .599v9.511l-.538-.21-1.858-.734c-.112-.045-.199-.025-.258.056-.053.072-.043.17.022.254a421.181 421.181 0 0 1 1.798 2.336L3.01 13.54c.222.289.443.58.667.867.03.04.08.067.12.1h.108ZM12.973 11.93v1.48c0 .294.004.589-.002.883-.01.405-.262.71-.642.79a.778.778 0 0 1-.87-.45 1.065 1.065 0 0 1-.075-.395c-.007-.72-.003-1.442-.003-2.163v-.151h-.135c-.473 0-.946.003-1.42 0-.492-.006-.842-.366-.823-.843.015-.366.308-.699.674-.733.25-.023.504-.014.755-.015.31-.002.62 0 .94 0V8.744h-.12c-.492 0-.985.004-1.477-.001a.786.786 0 0 1-.763-.658.78.78 0 0 1 .47-.858.954.954 0 0 1 .338-.065c.473-.007.946-.003 1.42-.003h.141V2.443c0-.56.155-1.071.507-1.511.463-.582 1.07-.906 1.814-.913 1.236-.013 2.474-.038 3.71.005 1.632.058 2.888.823 3.716 2.227 1.396 2.365.222 5.28-2.213 6.21-.467.178-.952.279-1.453.28-1.427.004-2.853.005-4.28.003h-.203v1.588h6.27c.404 0 .701.192.821.527.188.526-.194 1.058-.772 1.063-.679.006-1.357.002-2.036.002H13.1c-.037 0-.075.003-.127.006Zm0-4.771h.345c1.33 0 2.659.003 3.989 0 1.524-.004 2.749-1.172 2.809-2.673.06-1.523-1.261-2.876-2.827-2.884-1.166-.006-2.333-.002-3.5 0a.924.924 0 0 0-.274.041c-.349.11-.542.406-.543.816V7.16Z"
    />
  </svg>
);

export const MoneyFlowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#282828"
      d="M3.905 0c.093.1.191.195.275.301.316.407.627.818.94 1.227l.947 1.231L7.59 4.737c.03.037.058.077.084.118.045.073.038.147-.01.215a.175.175 0 0 1-.211.063c-.282-.108-.563-.219-.844-.33l-1.56-.614c-.008-.004-.018-.005-.036-.01v10.097c0 .165-.066.232-.232.232H2.913c-.159 0-.224-.064-.225-.222-.002-.2 0-.4 0-.6v-9.51l-.538.21-1.858.734c-.112.044-.199.025-.258-.057-.053-.072-.043-.17.022-.254a434.921 434.921 0 0 0 1.798-2.335L3.01.968c.222-.29.443-.58.667-.867.03-.04.08-.067.12-.1L3.906 0ZM12.973 11.93v1.48c0 .294.004.589-.002.883-.01.405-.262.71-.642.79a.778.778 0 0 1-.87-.45 1.065 1.065 0 0 1-.075-.395c-.007-.72-.003-1.442-.003-2.163v-.151h-.135c-.473 0-.946.003-1.42 0-.492-.006-.842-.366-.823-.843.015-.366.308-.699.674-.733.25-.023.504-.014.755-.015.31-.002.62 0 .94 0V8.744h-.12c-.492 0-.985.004-1.477-.001a.786.786 0 0 1-.763-.658.78.78 0 0 1 .47-.858.954.954 0 0 1 .338-.065c.473-.007.946-.003 1.42-.003h.141V2.443c0-.56.155-1.071.507-1.511.463-.582 1.07-.906 1.814-.913 1.236-.013 2.474-.038 3.71.005 1.632.058 2.888.823 3.716 2.227 1.396 2.365.222 5.28-2.213 6.21-.467.178-.952.279-1.453.28-1.427.004-2.853.005-4.28.003h-.203v1.588h6.27c.404 0 .701.192.821.527.188.526-.194 1.058-.772 1.063-.679.006-1.357.002-2.036.002H13.1c-.037 0-.075.003-.127.006Zm0-4.771h.345c1.33 0 2.659.003 3.989 0 1.524-.004 2.749-1.172 2.809-2.673.06-1.523-1.261-2.876-2.827-2.884-1.166-.006-2.333-.002-3.5 0a.924.924 0 0 0-.274.041c-.349.11-.542.406-.543.816V7.16Z"
    />
  </svg>
);
